import { useEffect } from 'react';

import { NextPage, useRouter } from '@eneco/next';
import { signIn } from 'next-auth/react';

const ChampionLoginPage: NextPage = () => {
  const { basePath, isReady, query, locale } = useRouter();

  useEffect(() => {
    if (!isReady) return;

    signIn('okta-champions', { callbackUrl: `/${locale}/my-eneco/impersonation` });
  }, [basePath, isReady, query, locale]);

  return null;
};

export default ChampionLoginPage;
